import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const ConfirmDeleteModal = ({ isOpen, onClose, onDelete }) => (
  <Modal
    className="tvt-my-reports__modal"
    show={isOpen}
    onHide={onClose}
    backdrop
  >
    <Modal.Header>
      <Modal.Title>Delete?</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      Are you sure you want to delete this report?
      <br />
      You cannot undo this action.
    </Modal.Body>

    <Modal.Footer>
      <Button onClick={onClose}>No, Go Back</Button>
      <Button onClick={onDelete}>Yes, Delete</Button>
    </Modal.Footer>
  </Modal>
);

ConfirmDeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ConfirmDeleteModal;
